import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import {
    setAnimationStage,
    showChooseABacteriaSection,
    hideChooseABacteriaSection,
    changeExitingStatus,
    resetActiveFeature
} from '../actions';
import Idler from '../components/idler';

// Components
import AnimationMap from '../components/animation-map';
import ChooseABacteria from '../components/choose-a-bacteria';
import BackButton from '../components/back-button';

import AnimationNew from "../components/animation-new";

class AnimationPage extends Component{

    constructor(props) {
        super(props);

        this._entranceAnimation = this._entranceAnimation.bind(this);
        this._exitAnimation = this._exitAnimation.bind(this);
        this._initCounters = this._initCounters.bind(this);

        this.stepper = null;
        this.animationCountdown = null;
        this.animationPause = null;
    }

    componentDidMount() {
        const { resetFeatures, choiceStatus } = this.props;

        if( !choiceStatus ) {
            this._entranceAnimation();
        }

        resetFeatures();
    }

    componentWillUnmount() {
        clearInterval( this.stepper );
        clearTimeout( this.animationCountdown );
        clearTimeout( this.animationPause );
    }

    _entranceAnimation() {
        const animationPause = 4000; // The time the animation is paused.

        this.animationPause = setTimeout( () => {
            this._initCounters();
        }, animationPause);

    }

    _initCounters() {
        const { setStage, showChoices } = this.props;
        const animationSectionLength = 6000; // The time between each ite.
        const animationTotal = 26000; // The total time.
        const totalSteps = 5;

        let currentStep = 1;
        this.stepper = setInterval( () => {
            currentStep++;
            setStage( currentStep );

            if( currentStep === totalSteps ) {
                clearInterval( this.stepper );
            }
        }, animationSectionLength );

        this.animationCountdown = setTimeout( () => {
            showChoices();
        }, animationTotal );
    }

    _exitAnimation(){
        const { goBack } = this.props;
        goBack();
    }

    render() {
        const { choiceStatus } = this.props;

        return(
            <div className="animation-page">
                { choiceStatus &&
                    <Idler/>
                }
                { choiceStatus &&
                    <BackButton onClick={ this._exitAnimation } />
                }
                <div className="animation-container">
                    <AnimationNew skip={ choiceStatus } />
                    {choiceStatus &&
                        <div className="choose-a-bacteria-container">
                            <ChooseABacteria />
                        </div>
                    }
                </div>
                <div className="animation-zoom-level">

                </div>
                <div className="animation-map">
                    <AnimationMap />
                </div>
            </div>
        );
    }

}

const mapStateToProps = ( state ) => {
    return{
        currentStage: state.animationStage,
        choiceStatus: state.chooseABacteriaStatus,
        isExiting: state.animationStatus.isExiting
    }
};

const mapDispatchToProps = ( dispatch ) => {
    return{
        setStage: ( stage ) => {
            dispatch(setAnimationStage(stage));
        },
        showChoices: () => {
            dispatch(showChooseABacteriaSection());
        },
        startExit: () => {
            dispatch(changeExitingStatus(true));
        },
        hideChoices: () => {
            dispatch(hideChooseABacteriaSection());
        },
        goBack: () => {
            dispatch(push( process.env.PUBLIC_URL + '/' ) );
        },
        resetFeatures: () => {
            dispatch(resetActiveFeature());
        }
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(AnimationPage);



// WEBPACK FOOTER //
// ./src/pages/animation-page.js